import { Pane, Heading, Paragraph, UnorderedList, ListItem, Text, Table, Link, Alert } from 'evergreen-ui';

const InformativaOspitiPage = () => {
  return (
    <Pane maxWidth={900} marginX="auto" padding={32}>

      <Heading size={900} marginBottom={8}>
        Informativa sul trattamento dei dati personali degli Ospiti
      </Heading>
      <Paragraph size={300} color="muted" marginBottom={8}>
        Ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (GDPR) — Versione 2.0 del 01/06/2026
      </Paragraph>
      <Paragraph size={300} color="muted" marginBottom={32}>
        Destinatari: ospiti (minori) accolti presso Casa Letizia GAAG e genitori/tutori legali esercenti la responsabilità genitoriale.
      </Paragraph>

      <Alert intent="warning" title="Trattamento di categorie particolari di dati" marginBottom={32}>
        La presente informativa riguarda il trattamento di dati personali appartenenti a categorie
        particolari ai sensi dell'art. 9 del GDPR (dati relativi alla salute, alla situazione
        familiare, a eventuali disabilità) e di dati giudiziari ai sensi dell'art. 10 del GDPR
        (provvedimenti dell'Autorità Giudiziaria, affidamenti, adozioni). Tali dati godono di
        una protezione rafforzata e sono trattati esclusivamente dal personale autorizzato, per
        le finalità strettamente necessarie indicate di seguito.
      </Alert>

      {/* ------------------------------------------------------------------ */}
      {/* 1. TITOLARE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>1. Titolare del trattamento</Heading>
      <Paragraph size={400} marginBottom={4}>
        <strong>Casa Letizia GAAG</strong> (Gruppo Appartamento Adolescenti e Giovani)
      </Paragraph>
      <Paragraph size={400} marginBottom={4}>Via Vandalino 25, 10093 Collegno (TO) — Italia</Paragraph>
      <Paragraph size={400} marginBottom={4}>Codice Fiscale / P.IVA: 13037730010</Paragraph>
      <Paragraph size={400} marginBottom={32}>
        E-mail: <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link>
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 2. CATEGORIE DI DATI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>2. Categorie di dati personali trattati</Heading>
      <Paragraph size={400} marginBottom={12}>
        Nell'ambito della presa in carico educativa dell'ospite, Casa Letizia GAAG tratta le
        seguenti categorie di dati personali:
      </Paragraph>

      <Heading size={500} marginBottom={8}>2.1 Dati identificativi e anagrafici (dati comuni)</Heading>
      <UnorderedList marginBottom={16}>
        <ListItem>Nome, cognome, data e luogo di nascita, codice fiscale;</ListItem>
        <ListItem>Indirizzo di residenza o domicilio, comune, provincia;</ListItem>
        <ListItem>Recapiti diretti (telefono, e-mail, IBAN se applicabile);</ListItem>
        <ListItem>Dati anagrafici dei genitori, tutori o esercenti la responsabilità genitoriale (nome, cognome, telefono, e-mail, indirizzo);</ListItem>
        <ListItem>Contatti del <strong>padre</strong> e della <strong>madre</strong> (nome, cognome, telefono, e-mail, indirizzo) — raccolti separatamente ove entrambe le figure siano coinvolte nel percorso;</ListItem>
        <ListItem>Contatti dell'avvocato, dell'assistente sociale di riferimento, dello specialista sanitario e del SERD, ove applicabile;</ListItem>
        <ListItem>Informazioni sulla composizione del nucleo familiare e sulla situazione familiare.</ListItem>
      </UnorderedList>

      <Heading size={500} marginBottom={8}>
        2.2 Categorie particolari di dati — art. 9 GDPR (dati sensibili)
      </Heading>
      <Paragraph size={400} marginBottom={8}>
        I seguenti dati rientrano nelle categorie particolari ai sensi dell'art. 9 del GDPR e sono
        trattati solo in presenza di idonea base giuridica (vedi sezione 3):
      </Paragraph>
      <UnorderedList marginBottom={16}>
        <ListItem>
          <strong>Piano Educativo Individualizzato (PEI)</strong> — documento che descrive il
          percorso educativo personalizzato dell'ospite, incluse eventuali indicazioni relative
          a condizioni di salute, disabilità o difficoltà specifiche;
        </ListItem>
        <ListItem>
          <strong>Dati relativi alla salute e a condizioni di disabilità</strong> — certificazioni
          sanitarie, verbali di invalidità, diagnosi funzionali, relazioni di specialisti;
        </ListItem>
        <ListItem>
          <strong>Dati psicologici e psichiatrici</strong> — relazioni di psicologi, neuropsichiatri
          infantili, SERT o altri servizi sanitari;
        </ListItem>
        <ListItem>
          <strong>Dati sull'origine etnica o razziale</strong> — solo se rilevanti per il
          progetto educativo individuale;
        </ListItem>
        <ListItem>
          <strong>Dati relativi alla situazione socio-economica della famiglia</strong> — nella
          misura necessaria alla predisposizione del progetto educativo.
        </ListItem>
      </UnorderedList>

      <Heading size={500} marginBottom={8}>
        2.3 Dati giudiziari — art. 10 GDPR
      </Heading>
      <Paragraph size={400} marginBottom={8}>
        I seguenti dati riguardano provvedimenti dell'Autorità Giudiziaria e sono trattati solo
        se strettamente necessario per l'adempimento degli obblighi di legge:
      </Paragraph>
      <UnorderedList marginBottom={16}>
        <ListItem>
          Decreti e provvedimenti del <strong>Tribunale per i Minorenni</strong> (allontanamento,
          affidamento eterofa­miliare, inserimento in comunità, decadenza/limitazione potestà
          genitoriale);
        </ListItem>
        <ListItem>
          Verbali e atti relativi a <strong>procedimenti penali</strong> a carico di familiari che
          abbiano diretto impatto sulla situazione dell'ospite;
        </ListItem>
        <ListItem>
          Provvedimenti relativi ad <strong>adozioni o affidamenti</strong> (L. 184/1983,
          L. 149/2001).
        </ListItem>
      </UnorderedList>

      <Heading size={500} marginBottom={8}>2.4 Campi personalizzati</Heading>
      <Paragraph size={400} marginBottom={8}>
        Il sistema gestionale consente al direttore di definire <strong>campi a struttura libera</strong> associati al singolo ospite (es. "Allergie", "Medico di base", "Note legali specifiche"). Il Titolare è responsabile di garantire che tali campi:
      </Paragraph>
      <UnorderedList marginBottom={16}>
        <ListItem>rispettino il principio di minimizzazione (art. 5.1.c GDPR) — non raccolgano dati superiori a quelli necessari;</ListItem>
        <ListItem>qualora contengano dati relativi alla salute o dati giudiziari, siano trattati con le cautele previste dagli artt. 9-10 GDPR.</ListItem>
      </UnorderedList>

      <Heading size={500} marginBottom={8}>2.5 Documenti allegati</Heading>
      <UnorderedList marginBottom={32}>
        <ListItem>Copia del documento di identità dell'ospite e/o dei genitori/tutori;</ListItem>
        <ListItem>Tessera sanitaria, libretto sanitario;</ListItem>
        <ListItem>Relazioni sociali elaborate dai Servizi Sociali del Comune inviante;</ListItem>
        <ListItem>Relazioni scolastiche (con il consenso dell'istituto);</ListItem>
        <ListItem>Ogni altro documento necessario all'attuazione del progetto educativo individuale.</ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 3. FINALITÀ E BASI GIURIDICHE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>3. Finalità del trattamento e basi giuridiche</Heading>

      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Finalità</Table.TextHeaderCell>
            <Table.TextHeaderCell>Base giuridica</Table.TextHeaderCell>
            <Table.TextHeaderCell>Riferimento normativo</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Presa in carico e gestione del progetto educativo individuale dell'ospite
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.c GDPR (adempimento di obblighi legali) + art. 6.1.e GDPR (esecuzione
                di compiti di interesse pubblico) + art. 9.2.g GDPR (motivi di interesse pubblico
                rilevante nel settore dell'assistenza sociale)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>L. 328/2000 art. 22; D.Lgs. 112/1998; normative regionali</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Gestione e aggiornamento del Piano Educativo Individualizzato (PEI) e del diario
                educativo
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.c + art. 6.1.e GDPR + art. 9.2.g GDPR
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>L. 328/2000; linee guida regionali per le comunità educative</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Comunicazioni con l'ente inviante (Servizi Sociali del Comune), il Tribunale per
                i Minorenni, la scuola, la ASL, i servizi psichiatrici
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.c GDPR (obbligo legale di rendicontazione e collaborazione istituzionale)
                + art. 9.2.g GDPR
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>L. 184/1983; D.P.R. 448/1988; L. 328/2000</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Esecuzione di provvedimenti dell'Autorità Giudiziaria minorile
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.c GDPR + art. 10 GDPR (dati giudiziari in base a norma di legge)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>L. 184/1983; L. 149/2001; D.P.R. 448/1988</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Gestione delle emergenze sanitarie e di sicurezza dell'ospite
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.d GDPR (salvaguardia degli interessi vitali dell'interessato) + art.
                9.2.c GDPR (necessità di tutela di interessi vitali)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Normativa generale in materia di tutela dei minori</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Adempimenti amministrativi, contabili e di rendicontazione verso gli enti
                finanziatori (Comuni, Regione, ASL)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Art. 6.1.c GDPR (obblighi di legge e di rendicontazione)
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Normativa regionale e contratti di servizio con gli enti invianti</Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>

      <Paragraph size={400} marginBottom={32}>
        I dati non vengono trattati per finalità di marketing, profilazione commerciale, ricerche
        di mercato o per finalità diverse da quelle indicate nella tabella sopra. Qualsiasi
        trattamento ulteriore sarà soggetto a una specifica informativa.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 4. PERSONALE AUTORIZZATO */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>4. Personale autorizzato al trattamento</Heading>
      <Paragraph size={400} marginBottom={12}>
        I dati degli ospiti sono accessibili esclusivamente al personale di Casa Letizia GAAG
        che è stato formalmente autorizzato al trattamento (art. 29 GDPR). L'accesso ai dati è
        differenziato in base al ruolo:
      </Paragraph>
      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Ruolo</Table.TextHeaderCell>
            <Table.TextHeaderCell>Livello di accesso</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><strong>Direttore</strong></Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Accesso completo a tutte le sezioni: anagrafica, PEI, allegati, diario educativo,
                note riservate, comunicazioni con gli enti.
              </Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><strong>Educatori</strong></Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Accesso all'anagrafica, al PEI, al diario educativo e agli allegati. Accesso alle
                note non riservate. Non hanno accesso a dati contrattuali o finanziari.
              </Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><strong>Operatori</strong></Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Accesso limitato: anagrafica essenziale, diario (lettura e inserimento note di
                turno). Non hanno accesso al PEI completo, agli allegati sanitari o alle note
                riservate.
              </Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><strong>Collaboratori avanzati</strong></Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Collaboratori (educatori o operatori) con livello avanzato abilitato dalla direzione.
                Accedono alle stesse funzioni del direttore per la gestione degli ospiti, inclusi
                anagrafica completa, note altrui, campi personalizzati e gestione turni. Il livello
                avanzato è documentato nel fascicolo del personale.
              </Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>
      <Paragraph size={400} marginBottom={32}>
        Tutto il personale autorizzato è vincolato da obbligo di riservatezza, sia contrattuale
        che derivante dalla normativa vigente. L'accesso al sistema avviene tramite credenziali
        personali; ogni operazione è tracciata nei log del sistema.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 5. DESTINATARI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>5. Destinatari dei dati</Heading>
      <Paragraph size={400} marginBottom={12}>
        I dati personali degli ospiti possono essere comunicati, nei limiti strettamente necessari
        e in presenza di base giuridica idonea, ai seguenti soggetti:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          <strong>Ente inviante (Comune, Municipio, Servizi Sociali territoriali)</strong> —
          per la rendicontazione del percorso educativo e gli aggiornamenti periodici previsti dal
          contratto di servizio e dalla normativa.
        </ListItem>
        <ListItem>
          <strong>Tribunale per i Minorenni</strong> — per adempiere ai provvedimenti giudiziari
          e comunicare le relazioni di aggiornamento richieste.
        </ListItem>
        <ListItem>
          <strong>Azienda Sanitaria Locale (ASL) / Servizi di Neuropsichiatria Infantile (NPIA)</strong>{' '}
          — per il coordinamento delle cure sanitarie e psicologiche dell'ospite.
        </ListItem>
        <ListItem>
          <strong>Istituto scolastico frequentato dall'ospite</strong> — per la condivisione delle
          informazioni necessarie al percorso scolastico, nel rispetto della normativa sulla
          privacy in ambito scolastico.
        </ListItem>
        <ListItem>
          <strong>Forze dell'ordine e Autorità giudiziaria</strong> — esclusivamente se richiesto
          da provvedimento dell'autorità o in caso di urgenza.
        </ListItem>
        <ListItem>
          <strong>Fornitore del software gestionale</strong> — quale responsabile del trattamento
          ex art. 28 GDPR, per la fornitura e manutenzione del sistema informatico; i dati
          non vengono utilizzati dal fornitore per finalità proprie.
        </ListItem>
        <ListItem>
          <strong>Medici e specialisti di riferimento dell'ospite</strong> — nei casi in cui sia
          necessario per la tutela della salute del minore.
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        I dati non vengono venduti, ceduti o comunicati a terzi per finalità commerciali. La
        diffusione dei dati degli ospiti è assolutamente vietata, salvo nei casi previsti dalla
        legge (es. pubblicazione in atti giudiziari con pseudonimizzazione obbligatoria).
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 6. TRASFERIMENTO EXTRA-UE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>6. Trasferimento verso paesi terzi</Heading>
      <Paragraph size={400} marginBottom={32}>
        I dati personali degli ospiti non vengono trasferiti verso paesi terzi al di fuori
        dell'Unione Europea o dello Spazio Economico Europeo. Il server che ospita il sistema
        gestionale è ubicato in Italia o nell'Unione Europea.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 7. CONSERVAZIONE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>7. Periodo di conservazione</Heading>
      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Categoria di dato</Table.TextHeaderCell>
            <Table.TextHeaderCell>Periodo di conservazione</Table.TextHeaderCell>
            <Table.TextHeaderCell>Motivazione</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Fascicolo personale dell'ospite (anagrafica, PEI, diario)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>10 anni dalla data di uscita dalla struttura</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Principio di necessità GDPR + prassi consolidata nel settore dei servizi
                sociali per minori + eventuale necessità di ricostruzione del percorso in caso
                di procedimenti giudiziari o richieste degli enti invianti
              </Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Provvedimenti del Tribunale per i Minorenni</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Per tutta la durata del provvedimento + 10 anni, salvo diverse disposizioni
                dell'Autorità Giudiziaria
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Art. 6.1.c GDPR (obbligo di legge)</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Documenti sanitari e di salute</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>10 anni dalla data di uscita dalla struttura</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Prassi del settore sanitario-sociale</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Documenti amministrativi e di rendicontazione verso gli enti
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>10 anni</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>D.P.R. 600/1973 (obblighi di conservazione fiscale)</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Log di accesso al sistema informativo</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>12 mesi</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Principio di minimizzazione GDPR</Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>
      <Paragraph size={400} marginBottom={32}>
        Trascorsi i periodi di conservazione indicati, i dati saranno cancellati o anonimizzati
        in modo irreversibile. La cancellazione avviene in modo sicuro, secondo procedure che
        impediscono il recupero dei dati.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 8. MISURE DI SICUREZZA */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>8. Misure di sicurezza</Heading>
      <Paragraph size={400} marginBottom={12}>
        In considerazione della particolare sensibilità dei dati trattati (minori, dati di salute,
        dati giudiziari), Casa Letizia GAAG adotta le seguenti misure di sicurezza tecniche e
        organizzative ai sensi dell'art. 32 GDPR:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          <strong>Autenticazione con credenziali personali</strong> — ogni utente accede con
          username e password personali; è vietata la condivisione delle credenziali.
        </ListItem>
        <ListItem>
          <strong>Controllo degli accessi basato su ruoli</strong> — ciascun operatore vede
          solo i dati necessari alle proprie mansioni.
        </ListItem>
        <ListItem>
          <strong>Trasmissione cifrata</strong> — tutte le comunicazioni tra browser e server
          avvengono tramite protocollo HTTPS (TLS).
        </ListItem>
        <ListItem>
          <strong>Password in hash crittografico</strong> — le password di accesso al sistema
          non sono mai conservate in chiaro.
        </ListItem>
        <ListItem>
          <strong>Log degli accessi</strong> — ogni accesso al sistema è registrato con
          timestamp, utente e operazione eseguita.
        </ListItem>
        <ListItem>
          <strong>Backup periodici</strong> — i dati sono soggetti a procedure di backup
          per garantire la continuità operativa.
        </ListItem>
        <ListItem>
          <strong>Procedura di gestione dei data breach</strong> — in caso di violazione dei
          dati, Casa Letizia GAAG notificherà il Garante entro 72 ore (art. 33 GDPR) e
          informerà gli interessati se la violazione è ad alto rischio (art. 34 GDPR).
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 9. DIRITTI DEGLI INTERESSATI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>9. Diritti degli interessati</Heading>
      <Paragraph size={400} marginBottom={12}>
        Gli ospiti maggiorenni e i genitori/tutori legali degli ospiti minorenni hanno il diritto
        di esercitare i seguenti diritti nei confronti del Titolare del trattamento, ai sensi
        degli artt. 15-22 del GDPR:
      </Paragraph>
      <UnorderedList marginBottom={16}>
        <ListItem>
          <strong>Diritto di accesso (art. 15)</strong> — ottenere conferma che siano in
          corso trattamenti di dati che li riguardano e, in tal caso, ottenerne copia.
        </ListItem>
        <ListItem>
          <strong>Diritto di rettifica (art. 16)</strong> — ottenere la rettifica di dati
          inesatti o l'integrazione di dati incompleti.
        </ListItem>
        <ListItem>
          <strong>Diritto alla cancellazione (art. 17)</strong> — nei casi previsti dalla norma.
          Si precisa che, per i dati trattati in base a obblighi di legge o provvedimenti
          dell'Autorità Giudiziaria, il diritto alla cancellazione potrebbe essere limitato.
        </ListItem>
        <ListItem>
          <strong>Diritto di limitazione (art. 18)</strong> — ottenere la limitazione del
          trattamento nei casi previsti dalla norma.
        </ListItem>
        <ListItem>
          <strong>Diritto alla portabilità (art. 20)</strong> — ricevere i dati in formato
          strutturato e leggibile, se il trattamento è basato su consenso e avviene con
          mezzi automatizzati.
        </ListItem>
        <ListItem>
          <strong>Diritto di opposizione (art. 21)</strong> — opporsi al trattamento per
          motivi connessi alla propria situazione particolare. Si precisa che, per i
          trattamenti basati su obblighi legali o compiti di interesse pubblico, il diritto
          di opposizione potrebbe essere limitato.
        </ListItem>
      </UnorderedList>

      <Alert intent="none" title="Nota per i minori" marginBottom={24}>
        Per gli ospiti di età inferiore ai 14 anni, i diritti sopra elencati devono essere
        esercitati dai genitori o dai tutori legali. Per gli ospiti di età compresa tra 14 e 18
        anni, i diritti possono essere esercitati direttamente dall'ospite o congiuntamente con
        il tutore. In presenza di provvedimenti del Tribunale per i Minorenni che limitino la
        responsabilità genitoriale, i diritti sono esercitati secondo quanto stabilito dal
        provvedimento dell'Autorità Giudiziaria.
      </Alert>

      <Paragraph size={400} marginBottom={32}>
        Per esercitare i propri diritti è possibile contattare il Titolare del trattamento
        all'indirizzo e-mail{' '}
        <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link> oppure per iscritto
        all'indirizzo della sede legale (Via Vandalino 25, 10093 Collegno TO). Il Titolare
        risponderà entro 30 giorni dalla ricezione della richiesta, prorogabili di ulteriori
        60 giorni in caso di complessità.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 10. RECLAMO AL GARANTE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>10. Diritto di reclamo al Garante</Heading>
      <Paragraph size={400} marginBottom={12}>
        Hai il diritto di proporre reclamo all'Autorità di controllo competente. In Italia
        l'Autorità di controllo è il <strong>Garante per la protezione dei dati personali</strong>:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>Piazza Venezia, 11 — 00187 Roma (RM)</ListItem>
        <ListItem>Centralino: +39 06 696771</ListItem>
        <ListItem>E-mail: <Link href="mailto:garante@gpdp.it">garante@gpdp.it</Link></ListItem>
        <ListItem>PEC: <Link href="mailto:protocollo@pec.gpdp.it">protocollo@pec.gpdp.it</Link></ListItem>
        <ListItem>
          Sito web:{' '}
          <Link href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">
            www.garanteprivacy.it
          </Link>
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 11. FONTE DEI DATI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>11. Fonte dei dati personali</Heading>
      <Paragraph size={400} marginBottom={32}>
        I dati personali degli ospiti possono essere raccolti direttamente dall'interessato
        (o dai suoi genitori/tutori) al momento dell'ingresso in struttura, oppure ricevuti
        dall'ente inviante (Comune, Servizi Sociali, Tribunale per i Minorenni) in base a
        disposizioni di legge o a provvedimenti dell'Autorità Giudiziaria (art. 14 GDPR). In
        tal caso, Casa Letizia GAAG fornirà la presente informativa all'interessato o ai suoi
        rappresentanti legali entro un termine ragionevole e, al più tardi, al momento del
        primo contatto diretto.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* FOOTER */}
      {/* ------------------------------------------------------------------ */}
      <Pane borderTop="muted" paddingTop={16}>
        <Text size={300} color="muted">
          Versione 2.0 — Ultimo aggiornamento: 1 giugno 2026 | Base normativa: Reg. (UE)
          2016/679 (GDPR) artt. 9, 10, 13, 14 — D.Lgs. 196/2003 — L. 184/1983 — L. 328/2000
          — D.Lgs. 39/2014
        </Text>
      </Pane>
      <Pane marginTop={12}>
        <Text size={300} color="muted">
          Il fornitore del sito web non è responsabile della conformità legale dei contenuti di
          questa pagina, che è redatta e aggiornata a cura del Titolare del trattamento. Si
          raccomanda la validazione da parte di un professionista specializzato in GDPR.
        </Text>
      </Pane>

    </Pane>
  );
};

export default InformativaOspitiPage;
